// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2725":"c7d8c9e6b7a7d0ad","5112":"c71366e7cb570da2"}[chunkId] + ".css";
};